module.exports = __webpack_public_path__ + "img/ezstudio-logo.6d344722.png";